"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const rebass_1 = require("rebass");
function default_1(_a) {
    var { icon, children } = _a, rest = __rest(_a, ["icon", "children"]);
    return (react_1.default.createElement(rebass_1.Button, Object.assign({}, rest, { className: "fui-icon-button", css: {} }),
        react_1.default.createElement(rebass_1.Flex, { alignItems: "center" },
            icon,
            react_1.default.createElement("span", null, children))));
}
exports.default = default_1;
//# sourceMappingURL=IconButton.js.map